import React, { Dispatch, FC, SetStateAction, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, ButtonGroup } from '@progress/kendo-react-buttons'
import { Window } from '@progress/kendo-react-dialogs'
import {
  Card,
  CardBody,
  GridLayout,
  GridLayoutItem,
  StackLayout
} from '@progress/kendo-react-layout'
import { Popup } from '@progress/kendo-react-popup'
import { DispatchAllotmentSheet } from './DispatchAllotmentSheet'
import { BuildingSplit } from '../../building/maintenance/BuildingSplit'
import { BuildingMaintenance } from '../../building/maintenance/BuildingMaintenance'
import './SimulationBuildingSearch.css'
import { Marker } from '../../../components/elements'
import { GetSupplierAllocationGateway } from '../../../gateway/simulation/GetSupplierAllocationGateway'
import { DeleteSimulationBuildingGateway } from '../../../gateway/simulation/DeleteSimulationBuildingGateway'
import {
  AllocationSupplier,
  BuildingInfoExpense,
  GetSimulationBuildingListReq
} from '@gateway.Simulation'
import Constants from '../../../data/Constants.json'
import {
  SimulationBuildingSearchActions,
  CommonActions,
  useAppDispatch,
  useAppSelector
} from '../../../stores'
import {
  ConfirmDialog,
  ErrorMessage
} from '../../../components/parts'
import { BuildingMaintenanceGateway } from '../../../gateway/building/BuildingMaintenanceGateway'
import { BuildingInfoPut, BuildingInfoSplit, BuildingItemReq, PutBuildingItemReqObj } from '@gateway.Building'
import { MessageProvider } from '../../../services'
import { systemTime } from './SimulationBuildingSearch'
import produce from 'immer'
import dayjs from 'dayjs'
interface SimulationBuildingInformationCardProps {
  propsInfo: BuildingInfoExpense
  apiSimulationBuildingGateway: (searchCondition: GetSimulationBuildingListReq) => void
  setNotificationMessages: Dispatch<SetStateAction<ErrorMessage[]>>
  setErrorMessages: Dispatch<SetStateAction<ErrorMessage[]>>
  buildingList: BuildingInfoExpense[]
  setSimulationBuildingListState: React.Dispatch<React.SetStateAction<BuildingInfoExpense[]>>
}

export const SimulationBuildingInformationCard: FC<SimulationBuildingInformationCardProps> = (props) => {
  const BUILDING_INFO_PUT: BuildingInfoPut = {
    simulationYm: systemTime(),
    buildingNo: '',
    procurementNo: props.propsInfo.procurementNo,
    subNo: props.propsInfo.subNo,
    branchCd: props.propsInfo.branchCd,
    expense: props.propsInfo.expense,
    expenseSeq: props.propsInfo.expenseSeq,
    branchNm: props.propsInfo.branchNm,
    constructionKbn: props.propsInfo.constructionKbn,
    constructionKbnNm: props.propsInfo.constructionKbnNm,
    constructionNm: props.propsInfo.constructionNm,
    dispConstructionNm: props.propsInfo.dispConstructionNm,
    opportunityProgressCd: props.propsInfo.opportunityProgressCd,
    opportunityProgress: props.propsInfo.opportunityProgress,
    privateDecisionFlg: props.propsInfo.privateDecisionFlg,
    constructionFormCd: props.propsInfo.constructionFormCd,
    dispConstructionFormCd: props.propsInfo.dispConstructionFormCd,
    obtainHistoryCd: props.propsInfo.obtainHistoryCd,
    dispObtainHistoryCd: props.propsInfo.dispObtainHistoryCd,
    evaluationCd: props.propsInfo.evaluationCd,
    evaluation: props.propsInfo.evaluation,
    evaluationValueCd: props.propsInfo.evaluationValueCd,
    evaluationValue: props.propsInfo.evaluationValue,
    customerPartnershipCd: props.propsInfo.customerPartnershipCd,
    customerCd: props.propsInfo.customerCd,
    customerNm: props.propsInfo.customerNm,
    dispCustomerNm: props.propsInfo.dispCustomerNm,
    collabCustomerPartnershipCd: props.propsInfo.collabCustomerPartnershipCd,
    collabCustomerCd: props.propsInfo.collabCustomerCd,
    collabCustomerNm: props.propsInfo.collabCustomerNm,
    dispCollabCustomerNm: props.propsInfo.dispCollabCustomerNm,
    designerCustomerPartnershipCd: props.propsInfo.designerCustomerPartnershipCd,
    designerCustomerCd: props.propsInfo.designerCustomerCd,
    designerNm: props.propsInfo.designerNm,
    dispDesignerNm: props.propsInfo.dispDesignerNm,
    designKbn: props.propsInfo.designKbn,
    dispDesignKbn: props.propsInfo.dispDesignKbn,
    designKbnNm: props.propsInfo.designKbnNm,
    dispDesignKbnNm: props.propsInfo.dispDesignKbnNm,
    totalCost: props.propsInfo.totalCost,
    dispTotalCost: props.propsInfo.dispTotalCost,
    ourCompanyTotalCost: props.propsInfo.ourCompanyTotalCost,
    dispOurCompanyTotalCost: props.propsInfo.dispOurCompanyTotalCost,
    ourCompanyEquityRatio: props.propsInfo.ourCompanyEquityRatio,
    dispOurCompanyEquityRatio: props.propsInfo.dispOurCompanyEquityRatio,
    obtainYM: props.propsInfo.obtainYM,
    obtainFY: props.propsInfo.obtainFY,
    dispObtainFY: props.propsInfo.dispObtainFY,
    constructionSubjectCd: props.propsInfo.constructionSubjectCd,
    dispConstructionSubjectCd: props.propsInfo.dispConstructionSubjectCd,
    constructionSectionCd: props.propsInfo.constructionSectionCd,
    constructionSectionNm: props.propsInfo.constructionSectionNm,
    dispConstructionSectionNm: props.propsInfo.dispConstructionSectionNm,
    chiefPersonCd: props.propsInfo.chiefPersonCd,
    chiefPersonEmployeeNo: props.propsInfo.chiefPersonEmployeeNo,
    chiefPersonNm: props.propsInfo.chiefPersonNm,
    dispChiefPersonNm: props.propsInfo.dispChiefPersonNm,
    chiefPersonContacts: props.propsInfo.chiefPersonContacts,
    dispChiefPersonContacts: props.propsInfo.dispChiefPersonContacts,
    hqSalesSectionCd: props.propsInfo.hqSalesSectionCd,
    hqSalesSectionNm: props.propsInfo.hqSalesSectionNm,
    dispHqSalesSectionNm: props.propsInfo.dispHqSalesSectionNm,
    hqSalesPersonCd: props.propsInfo.hqSalesPersonCd,
    hqSalesPersonEmployeeNo: props.propsInfo.hqSalesPersonEmployeeNo,
    hqSalesPersonNm: props.propsInfo.hqSalesPersonNm,
    dispHqSalesPersonNm: props.propsInfo.dispHqSalesPersonNm,
    hqSalesPersonContacts: props.propsInfo.hqSalesPersonContacts,
    dispHqSalesPersonContacts: props.propsInfo.dispHqSalesPersonContacts,
    branchSalesSectionCd: props.propsInfo.branchSalesSectionCd,
    branchSalesSectionNm: props.propsInfo.branchSalesSectionNm,
    dispBranchSalesSectionNm: props.propsInfo.dispBranchSalesSectionNm,
    branchSalesPersonCd: props.propsInfo.branchSalesPersonCd,
    branchSalesPersonEmployeeNo: props.propsInfo.branchSalesPersonEmployeeNo,
    branchSalesPersonNm: props.propsInfo.branchSalesPersonNm,
    dispBranchSalesPersonNm: props.propsInfo.dispBranchSalesPersonNm,
    branchSalesPersonContacts: props.propsInfo.branchSalesPersonContacts,
    dispBranchSalesPersonContacts: props.propsInfo.dispBranchSalesPersonContacts,
    prefecture: props.propsInfo.prefecture,
    dispPrefecture: props.propsInfo.dispPrefecture,
    city: props.propsInfo.city,
    dispCity: props.propsInfo.dispCity,
    startYM: props.propsInfo.startYM,
    dispStartYM: props.propsInfo.dispStartYM,
    startY: props.propsInfo.dispStartYM?.substring(0, 4) ?? '',
    startM: props.propsInfo.dispStartYM?.substring(4, 6) ?? '',
    completionYM: props.propsInfo.completionYM,
    dispCompletionYM: props.propsInfo.dispCompletionYM,
    completionY: props.propsInfo.dispCompletionYM?.substring(0, 4) ?? '',
    completionM: props.propsInfo.dispCompletionYM?.substring(4, 6) ?? '',
    schedule: props.propsInfo.schedule,
    dispSchedule: props.propsInfo.dispSchedule,
    planSummary: props.propsInfo.planSummary,
    structureCd: props.propsInfo.structureCd,
    buildingServicesWorkFlg: props.propsInfo.buildingServicesWorkFlg,
    dispBuildingServicesWorkFlg: props.propsInfo.dispBuildingServicesWorkFlg,
    constructionCd: props.propsInfo.constructionCd,
    dispConstructionCd: props.propsInfo.dispConstructionCd,
    architectureUse: props.propsInfo.architectureUse,
    totalFloorAreaM2: props.propsInfo.totalFloorAreaM2,
    dispTotalFloorAreaM2: props.propsInfo.dispTotalFloorAreaM2,
    totalFloorAreaTsubo: props.propsInfo.totalFloorAreaTsubo,
    dispTotalFloorAreaTsubo: props.propsInfo.dispTotalFloorAreaTsubo,
    siteAreaM2: props.propsInfo.siteAreaM2,
    dispSiteAreaM2: props.propsInfo.dispSiteAreaM2,
    siteAreaTsubo: props.propsInfo.siteAreaTsubo,
    dispSiteAreaTsubo: props.propsInfo.dispSiteAreaTsubo,
    structureUnderGround: props.propsInfo.structureUnderGround,
    dispStructureUnderGround: props.propsInfo.dispStructureUnderGround,
    structureGround: props.propsInfo.structureGround,
    dispStructureGround: props.propsInfo.dispStructureGround,
    structurePenthouse: props.propsInfo.structurePenthouse,
    dispStructurePenthouse: props.propsInfo.dispStructurePenthouse,
    floorUnderGround: props.propsInfo.floorUnderGround,
    dispFloorUnderGround: props.propsInfo.dispFloorUnderGround,
    floorGround: props.propsInfo.floorGround,
    dispFloorGround: props.propsInfo.dispFloorGround,
    floorPenthouse: props.propsInfo.floorPenthouse,
    dispFloorPenthouse: props.propsInfo.dispFloorPenthouse,
    specialConstructionMethod: props.propsInfo.specialConstructionMethod,
    dispSpecialConstructionMethod: props.propsInfo.dispSpecialConstructionMethod,
    piling: props.propsInfo.piling,
    seismicIsolation: props.propsInfo.seismicIsolation,
    topDownFlg: props.propsInfo.topDownFlg,
    fixComment: props.propsInfo.fixComment,
    architectureUseCd1: props.propsInfo.architectureUseCd1,
    architectureUseNm1: props.propsInfo.architectureUseNm1,
    architectureUseCd2: props.propsInfo.architectureUseCd2,
    architectureUseNm2: props.propsInfo.architectureUseNm2,
    architectureUseCd3: props.propsInfo.architectureUseCd3,
    architectureUseNm3: props.propsInfo.architectureUseNm3,
    analyzationArchitectureUseCd1: props.propsInfo.analyzationArchitectureUseCd1,
    analyzationArchitectureUseNm1: props.propsInfo.analyzationArchitectureUseNm1,
    analyzationArchitectureUseCd2: props.propsInfo.analyzationArchitectureUseCd2,
    analyzationArchitectureUseNm2: props.propsInfo.analyzationArchitectureUseNm2,
    analyzationArchitectureUseCd3: props.propsInfo.analyzationArchitectureUseCd3,
    analyzationArchitectureUseNm3: props.propsInfo.analyzationArchitectureUseNm3,
    effortLevelCd: props.propsInfo.effortLevelCd,
    dispEffortLevelCd: props.propsInfo.dispEffortLevelCd,
    effortLevel: props.propsInfo.effortLevel,
    dispEffortLevel: props.propsInfo.dispEffortLevel,
    coreTopFlg: props.propsInfo.coreTopFlg,
    dispCoreTopFlg: props.propsInfo.dispCoreTopFlg,
    choiceAndConcentrationTarget: props.propsInfo.choiceAndConcentrationTarget,
    dispChoiceAndConcentrationTarget: props.propsInfo.dispChoiceAndConcentrationTarget,
    sagyosyoCd: props.propsInfo.sagyosyoCd,
    dispSagyosyoCd: props.propsInfo.dispSagyosyoCd,
    yamadumiNotApplicableYm: props.propsInfo.yamadumiNotApplicableYm,
    importDtm: props.propsInfo.importDtm,
    addUserKbn: props.propsInfo.addUserKbn,
    addDtm: props.propsInfo.addDtm,
    addUserCd: props.propsInfo.addUserCd,
    updUserKbn: props.propsInfo.updUserKbn,
    updDtm: props.propsInfo.updDtm,
    updUserCd: props.propsInfo.updUserCd,
    delFlg: 0,
    yamadumiFlg: props.propsInfo.yamadumiFlg,
    kenzaiDiscloseFlg: props.propsInfo.kenzaiDiscloseFlg,
    supplierDiscloseFlg: props.propsInfo.supplierDiscloseFlg,
    completedFlg: props.propsInfo.completedFlg,
    reportNonTargetFlg: props.propsInfo.reportNonTargetFlg,
    procurementSts: props.propsInfo.procurementSts,
    updSts: props.propsInfo.updSts,
    remark: props.propsInfo.remark,
    modeKbn: props.propsInfo.modeKbn
  }
  const navigate = useNavigate()
  const [confirmDialogShow, setConfirmDialogShow] = useState(false)
  const anchor = useRef<HTMLDivElement>(null)
  const [showFlg, setShowFlg] = useState(false)
  const [show, setShow] = useState(false)
  const simulationBuildingSearch = useAppSelector(
    (state) => state.simulationbuildingsearch.simulationBuildingSearch
  )
  const displayStartYear = useAppSelector(
    (state) => state.common.displayStartYear
  )
  const target = useAppSelector(
    (state) => state.simulationbuildingsearch.target
  )
  // 編集の状態
  const [showMaintenanceDialog, setShowMaintenanceDialog] = useState(false)
  // 分割の状態
  const [showSplitDialog, setShowSplitDialog] = useState(false)
  const [allocationSupplierList, setAllocationSupplierList] = useState<AllocationSupplier[]>([])
  const dispatch = useAppDispatch()

  const [messageId, setMessageId] = useState('')
  const [title, setTitle] = useState('')
  const [messageArgslist, setMessageArgslist] = useState([''])
  const [messageKey, setMessageKey] = useState('')
  // 編集登録
  const [maintenanceInfoPutState, setMaintenanceInfoPutState] = useState<BuildingInfoPut>(BUILDING_INFO_PUT)
  // 編集登録（初期表示時の状態をそのまま保持）
  const [maintenanceInfoPutStore, setMaintenanceInfoPutStore] = useState<BuildingInfoPut>(BUILDING_INFO_PUT)
  // 編集登録制御
  const [
    buildingMaintenanceSignInBtnDisabled,
    setBuildingMaintenanceSignInBtnDisabled
  ] = useState(false)
  // 分割登録
  const [splitInfoPutState, setSplitInfoPutState] = useState<BuildingItemReq[]>([])

  // Ｍ１進捗状況の表示方法について
  const opportunityProgressColor =
    (props.propsInfo.opportunityProgressKbn === '1' ||
      props.propsInfo.opportunityProgressKbn === '4') &&
    props.propsInfo.upperBuildingFlg === 0
      ? 'primary'
      : props.propsInfo.opportunityProgressKbn === '2' &&
        props.propsInfo.upperBuildingFlg === 0
        ? 'secondary'
        : props.propsInfo.opportunityProgressKbn === '3' &&
        props.propsInfo.upperBuildingFlg === 0
          ? 'accent'
          : undefined

  const userProp = useAppSelector((state) => state.common.userProp)

  // Ｍ１編集の制御
  const maintenanceStatus =
    props.propsInfo.expenseSeq === '00' ||
    (userProp?.authority === 4 && userProp?.branchCode !== props.propsInfo.branchCd)
  // Ｍ１分割の制御
  const splitStatus = () => {
    if (
      props.propsInfo.expenseSeq !== '00' ||
      props.propsInfo.yamadumiNotApplicableFlg === 1 ||
      (props.propsInfo.upperBuildingFlg === 0 &&
        props.propsInfo.manualYamadumiFlg === 1) ||
      (props.propsInfo.upperBuildingFlg === 1 &&
        props.propsInfo.expenseSplitFlg === 0) ||
      (userProp?.authority === 4 && userProp?.branchCode !== props.propsInfo.branchCd)
    ) {
      return true
    }
    return false
  }
  // Ｍ１配分の制御
  const allocationStatus = props.propsInfo.upperBuildingFlg === 1
  // Ｍ１削除の制御
  const deleteStatus = () => {
    if (
      props.propsInfo.expenseSeq === '00' ||
      (props.propsInfo.expenseSeq !== '00' &&
        props.propsInfo.yamadumiNotApplicableFlg === 1) ||
      (userProp?.authority === 4 && userProp?.branchCode !== props.propsInfo.branchCd)
    ) {
      return true
    }
    return false
  }

  /** 親物件、子物件、費目分割物件の表示方法 */
  const paddingLeft = () => {
    if (props.propsInfo.subNo === '00' && props.propsInfo.expenseSeq === '00') {
      return 0
    }
    if (props.propsInfo.subNo !== '00' && props.propsInfo.expenseSeq === '00') {
      return 30
    }
    if (props.propsInfo.expenseSeq !== '00') {
      return 60
    }
  }

  const isExpanded = ((props.buildingList
    .find((item) =>
      item.procurementNo === props.propsInfo.procurementNo &&
      item.subNo === props.propsInfo.subNo &&
      item.expenseSeq === props.propsInfo.expenseSeq)
    ?.isExpanded) ?? false)

  // 表示フラグ(展開済の子物件のみ表示)
  const isDisplay = isExpanded || (props.propsInfo.subNo === '00' && props.propsInfo.expenseSeq === '00')

  // 子物件が存在するかのフラグ
  const isExistChildren = props.buildingList
    .filter((item) => item.procurementNo === props.propsInfo.procurementNo).length > 1

  // 子物件を含め展開済にする
  const handleExpand = () => {
    props.setSimulationBuildingListState(produce((draft) => {
      draft.forEach((obj) => {
        if (obj.procurementNo === props.propsInfo.procurementNo) {
          obj.isExpanded = !obj.isExpanded
        }
      })
    }))
  }

  /** 山積対象物件一覧-削除 */
  const handleDelete = () => {
    setShowFlg(false)
    setMessageId('I014')
    setMessageKey('削除')
    setTitle('削除')
    setMessageArgslist([`${props.propsInfo.procurementNo ?? ''}-${props.propsInfo.subNo ?? ''}-${props.propsInfo.expenseSeq ?? ''}`])
    setConfirmDialogShow(true)
  }

  /** ConfirmDialog イベントの確認 */
  const dialogConfirmHandleBtn = () => {
    setConfirmDialogShow(false)
    // 削除
    if (messageKey === '削除') {
      let error = false
      dispatch(CommonActions.setIsLoading(true))
      DeleteSimulationBuildingGateway.putSimulationBuildingDelete({
        data: {
          simulationYm: systemTime(),
          procurementNo: props.propsInfo.procurementNo,
          subNo: props.propsInfo.subNo,
          branchCd: props.propsInfo.branchCd,
          expense: props.propsInfo.expense,
          expenseSeq: props.propsInfo.expenseSeq,
          buildingDiscloseFlgUpdDtm: props.propsInfo.buildingDiscloseFlgUpdDtm,
          kenzaiDiscloseFlgHistoryStsUpdDtm: props.propsInfo.upperBuildingFlgUpdDtm,
          manualYamadumiFlg: props.propsInfo.manualYamadumiFlg
        }
      })
        .then((res) => {
          error = res.error
          if (!res.error) {
            // 登録正常終了チェック
            props.setNotificationMessages([
              {
                id: 'I004',
                content: MessageProvider.provide('I004', ...['物件情報の削除'])
              }
            ])
          } else {
            if (Array.isArray(res.messages) && res.messages.length > 0) {
              const messages = res.messages.map<ErrorMessage>((message: any) => {
                return {
                  id: message.id,
                  content: message.message
                }
              })
              props.setErrorMessages(messages)
            }
          }
        })
        .finally(() => {
          dispatch(CommonActions.setIsLoading(false))
          if (!error) {
            // 山積対象物件一覧(データストア)の検索条件で再検索を行う
            props.apiSimulationBuildingGateway(simulationBuildingSearch)
          }
        })
    }
    if (messageKey === '編集戻る') {
      setShowMaintenanceDialog(false)
      return
    }
    if (messageKey === '編集登録') {
      const putBuildingItemReqObj: PutBuildingItemReqObj = {
        data: {
          buildingInfoList: []
        }
      }
      const buildingInfoPut = { ...maintenanceInfoPutState }
      // 削除フラグ
      buildingInfoPut.delFlg = 0
      // 更新ステータス
      buildingInfoPut.updSts = '2'

      putBuildingItemReqObj.data.buildingInfoList.push({
        buildingInfo: buildingInfoPut,
        flgChg: 0,
        updDtmParentBuildingHistoryStatus: null,
        updDtmBuildingHistoryStatus: null
      })

      let error = false
      dispatch(CommonActions.setIsLoading(true))
      BuildingMaintenanceGateway.putBuildingItem(putBuildingItemReqObj)
        .then((res) => {
          error = res.error
          if (!error) {
            const autoYamadumiNotPossibleBuildingList = res.data.autoYamadumiNotPossibleBuildingList
            if (autoYamadumiNotPossibleBuildingList.length > 0) {
              const requiredLackList: string[] = []
              const mismatchList: string[] = []
              for (const autoYamadumiNotPossibleBuilding of autoYamadumiNotPossibleBuildingList) {
                const { requiredLackBuildingList, mismatchBuildingList } = autoYamadumiNotPossibleBuilding
                if (requiredLackBuildingList.length > 0) {
                  requiredLackBuildingList.forEach((item) => {
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    requiredLackList.push(`${item.procurementNo}-${item.subNo}-${item.expenseSeq}`)
                  })
                }
                if (mismatchBuildingList.length > 0) {
                  mismatchBuildingList.forEach((item) => {
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    mismatchList.push(`${item.procurementNo}-${item.subNo}-${item.expenseSeq}`)
                  })
                }
              }
              if (requiredLackList.length > 0 && mismatchList.length > 0) {
                props.setErrorMessages([
                  {
                    id: 'I005',
                    content: MessageProvider.provide(
                      'I005',
                      ...[requiredLackList.join(',')]
                    )
                  },
                  {
                    id: 'I006',
                    content: MessageProvider.provide(
                      'I006',
                      ...[mismatchList.join(',')]
                    )
                  }
                ])
              }
              if (requiredLackList.length > 0 && mismatchList.length === 0) {
                props.setErrorMessages([
                  {
                    id: 'I005',
                    content: MessageProvider.provide(
                      'I005',
                      ...[requiredLackList.join(',')]
                    )
                  }
                ])
              }
              if (requiredLackList.length === 0 && mismatchList.length > 0) {
                props.setErrorMessages([
                  {
                    id: 'I006',
                    content: MessageProvider.provide(
                      'I006',
                      ...[mismatchList.join(',')]
                    )
                  }
                ])
              }
              if (requiredLackList.length === 0 && mismatchList.length === 0) {
                props.setNotificationMessages([
                  {
                    id: 'I004',
                    content: MessageProvider.provide('I004', ...['物件情報の登録'])
                  }
                ])
              }
              // 物件情報メンテナンス（編集）のウインドウを閉じる
              setShowMaintenanceDialog(false)
            } else {
              // 登録正常終了チェック
              props.setNotificationMessages([
                {
                  id: 'I004',
                  content: MessageProvider.provide('I004', ...['物件情報の登録'])
                }
              ])
              // 正常終了時、物件情報メンテナンス（編集）のウインドウを閉じる
              setShowMaintenanceDialog(false)
            }
          } else {
            const resMessages = res.messages
            if (Array.isArray(resMessages) && resMessages.length > 0) {
              const notificationMessages = resMessages.map<ErrorMessage>((message: any) => {
                return {
                  id: message.id,
                  content: message.message
                }
              })
              props.setErrorMessages(notificationMessages)
            }
          }
        })
        .finally(() => {
          dispatch(CommonActions.setIsLoading(false))
          if (!error) {
            // Storeにある検索条件で物件情報の再検索を行う
            props.apiSimulationBuildingGateway(simulationBuildingSearch)
          }
        })
      return
    }
    if (messageKey === '分割戻る') {
      setShowSplitDialog(false)
      return
    }
    if (messageKey === '分割登録') {
      const putBuildingItemReqObj: PutBuildingItemReqObj = {
        data: {
          buildingInfoList: []
        }
      }
      const buildingInfoPut: BuildingInfoSplit[] = []
      splitInfoPutState.forEach((buildingInfoSplit) => {
        const splitObj = Object.assign({}, JSON.parse(JSON.stringify(buildingInfoSplit)))
        splitObj.buildingInfo.kenzaiDiscloseFlg = 1
        splitObj.buildingInfo.yamadumiFlg = 1
        splitObj.buildingInfo.updDtmParentBuildingHistoryStatus = null
        buildingInfoPut.push(splitObj)
      })
      putBuildingItemReqObj.data.buildingInfoList = buildingInfoPut

      let error = false
      dispatch(CommonActions.setIsLoading(true))
      BuildingMaintenanceGateway.putBuildingItem(putBuildingItemReqObj)
        .then((res) => {
          error = res.error
          if (!error) {
            const autoYamadumiNotPossibleBuildingList = res.data.autoYamadumiNotPossibleBuildingList
            if (autoYamadumiNotPossibleBuildingList.length > 0) {
              const requiredLackList: string[] = []
              const mismatchList: string[] = []
              for (const autoYamadumiNotPossibleBuilding of autoYamadumiNotPossibleBuildingList) {
                const { requiredLackBuildingList, mismatchBuildingList } = autoYamadumiNotPossibleBuilding
                if (requiredLackBuildingList.length > 0) {
                  requiredLackBuildingList.forEach((item) => {
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    requiredLackList.push(`${item.procurementNo}-${item.subNo}-${item.expenseSeq}`)
                  })
                }
                if (mismatchBuildingList.length > 0) {
                  mismatchBuildingList.forEach((item) => {
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    mismatchList.push(`${item.procurementNo}-${item.subNo}-${item.expenseSeq}`)
                  })
                }
              }
              if (requiredLackList.length > 0) {
                props.setErrorMessages([
                  {
                    id: 'I005',
                    content: MessageProvider.provide(
                      'I005',
                      ...[requiredLackList.join(',')]
                    )
                  }
                ])
              }
              if (mismatchList.length > 0) {
                props.setErrorMessages([
                  {
                    id: 'I006',
                    content: MessageProvider.provide(
                      'I006',
                      ...[mismatchList.join(',')]
                    )
                  }
                ])
              }
              if (requiredLackList.length === 0 && mismatchList.length === 0) {
                props.setNotificationMessages([
                  {
                    id: 'I004',
                    content: MessageProvider.provide('I004', ...['物件情報の登録'])
                  }
                ])
                if (title === '編集の登録') {
                  setShowMaintenanceDialog(!showMaintenanceDialog)
                }
                if (title === '費目分割の登録') {
                  setShowSplitDialog(!showSplitDialog)
                }
              }
            } else {
              // 正常終了時、物件情報メンテナンス（編集）のウインドウを閉じる
              setShowMaintenanceDialog(false)
              // 登録正常終了チェック
              props.setNotificationMessages([
                {
                  id: 'I004',
                  content: MessageProvider.provide('I004', ...['物件情報の登録'])
                }
              ])
            }
          } else {
            const resMessages = res.messages
            if (Array.isArray(resMessages) && resMessages.length > 0) {
              const notificationMessages = resMessages.map<ErrorMessage>((message: any) => {
                return {
                  id: message.id,
                  content: message.message
                }
              })
              props.setErrorMessages(notificationMessages)
            }
          }
        })
        .finally(() => {
          dispatch(CommonActions.setIsLoading(false))
          if (!error) {
            // Storeにある検索条件で物件情報の再検索を行う
            props.apiSimulationBuildingGateway(simulationBuildingSearch)
          }
        })
    }
  }

  /** カード部押下 */
  const handleOnCardClick = () => {
    if (props.propsInfo.upperBuildingFlg !== 0) {
      return
    }

    setShowFlg(!showFlg)
    GetSupplierAllocationGateway.getSimulationSupplierAllocation({
      simulationYm: systemTime(),
      procurementNo: props.propsInfo.procurementNo ?? '',
      subNo: props.propsInfo.subNo ?? '',
      branchCd: props.propsInfo.branchCd ?? '',
      expense: props.propsInfo.expense ?? '',
      expenseSeq: props.propsInfo.expenseSeq ?? '',
      displayStartYear: displayStartYear ?? ''
    })
      .then((res) => {
        if (!res.error) {
          setAllocationSupplierList(res.data.allocationSupplierList)
        } else {
          const resMessages = res.messages
          if (Array.isArray(resMessages) && resMessages.length > 0) {
            const messages = resMessages.map<ErrorMessage>((message: any) => {
              return {
                id: message.id,
                content: message.message
              }
            })
            props.setErrorMessages(messages)
          }
        }
      })
      .finally(() => {})
  }

  const findShowInfo = (flg: number | string, key: string) => {
    if (typeof flg === 'number') {
      if (key === 'topDownFlg') {
        const findInfo = Constants.topdownFlag.find(
          (item) => item.code === flg.toString()
        )?.name
        return findInfo !== undefined ? findInfo : ''
      }
      const findInfo = Constants.presenceFlag.find(
        (item) => item.code === flg.toString()
      )?.name
      return findInfo !== undefined ? findInfo : ''
    }
    return ''
  }

  /** マウスオーバー */
  const diffInfo = () => {
    const diffList: string[] = []
    const info = props.propsInfo
    if (info.yamadumiNotApplicableFlg === 1) {
      // 山積対象外物件の場合は、差分表示は行わず「山積対象外」と表示する
      diffList.push('山積対象外')
      return diffList
    }
    let key: keyof BuildingInfoExpense
    for (key in info) {
      if (!key.includes('History')) {
        const historyKey = `${key}History` as keyof BuildingInfoExpense
        if (info[historyKey] !== null && info[historyKey] !== undefined && info[key] !== info[historyKey]) {
          switch (key) {
            case 'branchCd':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`支店:${info.branchNm ?? ''}`)
              break
            case 'evaluationValueCd':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`評価:${info.evaluationValue ?? ''}`)
              break
            case 'dispTotalFloorAreaM2':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`延床面積平米:${info.dispTotalFloorAreaM2?.toLocaleString() ?? ''}`)
              break
            case 'dispTotalFloorAreaTsubo':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`延床面積坪:${info.dispTotalFloorAreaTsubo?.toLocaleString() ?? ''}`)
              break
            case 'dispStructureUnderGround':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`構造-地下:${info.structureUnderGroundNm ?? ''}`)
              break
            case 'dispStructureGround':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`構造-地上:${info.structureGroundNm ?? ''}`)
              break
            case 'dispFloorUnderGround':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`階数-地下:${info.dispFloorUnderGround ?? ''}`)
              break
            case 'dispFloorGround':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`階数-地上:${info.dispFloorGround ?? ''}`)
              break
            case 'piling':
              diffList.push(`杭打:${findShowInfo(info.piling ?? '', 'piling')}`)
              break
            case 'seismicIsolation':
              diffList.push(
                `免震:${findShowInfo(info.seismicIsolation ?? '', 'seismicIsolation')}`
              )
              break
            case 'topDownFlg':
              diffList.push(`順打・逆打:${findShowInfo(info.topDownFlg ?? '', 'topDownFlg')}`)
              break
            case 'dispStartYM':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`着工年月:${info.dispStartYM ?? ''}`)
              break
            case 'dispCompletionYM':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`竣工年月:${info.dispCompletionYM ?? ''}`)
              break
            case 'dispSchedule':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`工期:${info.dispSchedule ?? ''}`)
              break
            case 'architectureUse':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`建物用途:${info.architectureUseNm ?? ''}`)
              break
            case 'dispSiteAreaM2':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`敷地面積平米:${info.dispSiteAreaM2?.toLocaleString() ?? ''}`)
              break
            case 'dispSiteAreaTsubo':
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              diffList.push(`敷地面積坪:${info.dispSiteAreaTsubo?.toLocaleString() ?? ''}`)
              break
          }
        }
      }
    }
    return diffList.join(' ')
  }
  /** 配分ボタン押下 */
  const handleAllocation = () => {
    dispatch(
      SimulationBuildingSearchActions.setAllocationInfo({
        simulationYm: systemTime(),
        procurementNo: props.propsInfo.procurementNo ?? '',
        subNo: props.propsInfo.subNo ?? '',
        branchCd: props.propsInfo.branchCd ?? '',
        expense: props.propsInfo.expense ?? '',
        expenseSeq: props.propsInfo.expenseSeq ?? '',
        displayStartYear: displayStartYear ?? ''
      })
    )
    navigate('/simulation/manual-simulation-allotment')
  }

  /** 編集戻る  */
  const closeMaintenanceDialog = () => {
    setMessageId('I003')
    setMessageKey('編集戻る')
    setTitle('確認')
    setConfirmDialogShow(true)
  }
  /** 編集登録 */
  const handleRegMaintenance = () => {
    setMessageId('I002')
    setMessageArgslist(['物件情報', '登録'])
    setMessageKey('編集登録')
    setTitle('編集の登録')
    setConfirmDialogShow(true)
  }

  /** 分割戻る */
  const closeSplitDialog = () => {
    setMessageId('I003')
    setMessageKey('分割戻る')
    setTitle('確認')
    setConfirmDialogShow(true)
  }
  /** 分割登録 */
  const handleRegSplit = () => {
    setMessageId('I002')
    setMessageArgslist(['物件情報', '登録'])
    setMessageKey('分割登録')
    setTitle('費目分割の登録')
    setConfirmDialogShow(true)
  }

  return (
    <>
      {(isDisplay ?? false) && (
      <>
      <div style={{ paddingLeft: paddingLeft() }}>
        <Card
          orientation="vertical"
          className={
            target === `${props.propsInfo.procurementNo ?? ''}-${props.propsInfo.subNo ?? ''}-${props.propsInfo.expenseSeq ?? ''}` && props.propsInfo.decisionChangeFlg === 1
              ? 'target-update-card-body'
              : target === `${props.propsInfo.procurementNo ?? ''}-${props.propsInfo.subNo ?? ''}-${props.propsInfo.expenseSeq ?? ''}`
                ? 'target-card-body'
                : props.propsInfo.decisionChangeFlg === 1 ? 'update-card-body' : ''
          }
          onClick={handleOnCardClick}
        >
          <CardBody style={{ paddingBottom: '11.5px' }}>
            <GridLayout gap={{ cols: 10 }}>
              <GridLayoutItem col={1}>
                <GridLayout>
                  <GridLayoutItem col={1} row={1}>
                    {props.propsInfo.updSts === '2'
                      ? (
                      <>
                        <div
                          onMouseEnter={() => setShow(!show)}
                          onMouseLeave={() => setShow(!show)}
                          ref={anchor}
                        >
                          <span
                            style={{
                              fontSize: '1.0em',
                              fontWeight: 'bold',
                              color: 'gray'
                            }}
                          >
                            {props.propsInfo.updStsNm}
                          </span>
                        </div>
                        <Popup
                          anchor={anchor.current}
                          show={show}
                          animate={false}
                          popupClass={'popup-content'}
                        >
                          <p style={{ margin: '15px' }}>{diffInfo()}</p>
                        </Popup>
                      </>
                        )
                      : (
                      <span
                        style={{
                          fontSize: '1.0em',
                          fontWeight: 'bold',
                          color: props.propsInfo.updSts === '1' ? 'red' : ''
                        }}
                      >
                        {props.propsInfo.updStsNm}
                      </span>
                        )}
                  </GridLayoutItem>
                  <GridLayoutItem col={2} row={1}>
                    <span
                      style={{
                        fontSize: '1.0em',
                        fontWeight: 'bold',
                        color: 'gray'
                      }}
                    >
                      {props.propsInfo.opportunityProgressNm !== null
                        ? (
                        <Marker themeColor={opportunityProgressColor}>
                          {props.propsInfo.opportunityProgressNm}
                          {props.propsInfo.opportunityProgressKbn === '1' && props.propsInfo.yamadumiAutoKbn === '2' ? '（適正工期）' : ''}
                        </Marker>
                          )
                        : (
                            ''
                          )}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={3} row={1}>
                    <span
                      style={{
                        fontSize: '1.0em',
                        fontWeight: 'normal',
                        color:
                          props.propsInfo.updSts === '2' &&
                          props.propsInfo.evaluationValueCdHistory !== null &&
                          props.propsInfo.evaluationValueCdHistory !== undefined &&
                          props.propsInfo.evaluationValueCd !==
                            props.propsInfo.evaluationValueCdHistory
                            ? '#D0611E'
                            : ''
                      }}
                    >
                      {props.propsInfo.evaluationValue}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={4} row={1}>
                    <span
                      style={{
                        fontSize: '1.0em',
                        fontWeight: 'normal',
                        color:
                          props.propsInfo.updSts === '2' &&
                          props.propsInfo.branchCdHistory !== null &&
                          props.propsInfo.branchCdHistory !== undefined &&
                          props.propsInfo.branchCd !==
                            props.propsInfo.branchCdHistory
                            ? '#D0611E'
                            : ''
                      }}
                    >
                      {props.propsInfo.branchNm}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={5} row={1} colSpan={3}>
                    <span style={{ fontWeight: 'normal', fontSize: '1.0em' }}>
                      {props.propsInfo.dispConstructionNm}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={2} colSpan={2}>
                    <span style={{ fontSize: '1.0em', fontWeight: 'normal' }}>
                      {props.propsInfo.procurementNo}-{props.propsInfo.subNo}-
                      {props.propsInfo.expenseSeq}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={3} row={2} colSpan={2}>
                    <span style={{ fontSize: '1.0em', fontWeight: 'normal' }}>
                      {props.propsInfo.dispConstructionSubjectCd}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={5} row={2}>
                    <span style={{ fontWeight: 'normal', fontSize: '1.0em' }}>
                      {props.propsInfo.constructionCdNm}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={6} row={2}>
                    <span
                      style={{
                        fontSize: '1.0em',
                        fontWeight: 'normal',
                        color:
                          props.propsInfo.updSts === '2' &&
                          props.propsInfo.dispStartYMHistory !== null &&
                          props.propsInfo.dispStartYMHistory !== undefined &&
                          props.propsInfo.dispStartYM !==
                            props.propsInfo.dispStartYMHistory
                            ? '#D0611E'
                            : ''
                      }}
                    >
                      {(props.propsInfo.dispStartYM != null) ? dayjs(props.propsInfo.dispStartYM).format('YYYY/MM') : ''}{' '}
                    </span>
                    <span style={{ fontSize: '1.0em', fontWeight: 'normal' }}>
                      -
                    </span>
                    <span
                      style={{
                        fontSize: '1.0em',
                        fontWeight: 'normal',
                        color:
                          props.propsInfo.updSts === '2' &&
                          props.propsInfo.dispCompletionYMHistory !== null &&
                          props.propsInfo.dispCompletionYMHistory !== undefined &&
                          props.propsInfo.dispCompletionYM !==
                            props.propsInfo.dispCompletionYMHistory
                            ? '#D0611E'
                            : ''
                      }}
                    >
                      {' '}{(props.propsInfo.dispCompletionYM != null) ? dayjs(props.propsInfo.dispCompletionYM).format('YYYY/MM') : ''}{' '}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={7} row={2}>
                    <span style={{ fontSize: '1.0em', fontWeight: 'normal' }}>
                      所長：{props.propsInfo.dispChiefPersonNm}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={8} row={2}>
                    <span style={{ fontSize: '1.0em', fontWeight: 'normal' }}>
                      担当：{props.propsInfo.personNm}
                    </span>
                  </GridLayoutItem>
                </GridLayout>
              </GridLayoutItem>
              <GridLayoutItem col={3}>
                <GridLayout>
                  <GridLayoutItem
                    col={1}
                    colSpan={2}
                    row={1}
                    style={{
                      fontSize: '0.8em',
                      fontWeight: 'normal',
                      textAlign: 'right'
                    }}
                  >
                    <ButtonGroup>
                      <Button
                        themeColor="secondary"
                        fillMode="flat"
                        onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
                          e.stopPropagation()
                          dispatch(SimulationBuildingSearchActions.setTarget(`${props.propsInfo.procurementNo ?? ''}-${props.propsInfo.subNo ?? ''}-${props.propsInfo.expenseSeq ?? ''}`))
                          setShowFlg(false)
                          setShowMaintenanceDialog(true)
                        }}
                        disabled={maintenanceStatus}
                        style={{ paddingTop: '0', paddingBottom: '0' }}
                      >
                        編集
                      </Button>
                      <Button
                        themeColor="secondary"
                        fillMode="flat"
                        onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
                          e.stopPropagation()
                          dispatch(SimulationBuildingSearchActions.setTarget(`${props.propsInfo.procurementNo ?? ''}-${props.propsInfo.subNo ?? ''}-${props.propsInfo.expenseSeq ?? ''}`))
                          setShowFlg(false)
                          setShowSplitDialog(true)
                        }}
                        disabled={splitStatus()}
                        style={{ paddingTop: '0', paddingBottom: '0' }}
                      >
                        分割
                      </Button>
                      <Button
                        themeColor="secondary"
                        fillMode="flat"
                        onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
                          e.stopPropagation()
                          dispatch(SimulationBuildingSearchActions.setTarget(`${props.propsInfo.procurementNo ?? ''}-${props.propsInfo.subNo ?? ''}-${props.propsInfo.expenseSeq ?? ''}`))
                          handleAllocation()
                        }}
                        disabled={allocationStatus}
                        style={{ paddingTop: '0', paddingBottom: '0' }}
                        autoFocus={target === `${props.propsInfo.procurementNo ?? ''}-${props.propsInfo.subNo ?? ''}-${props.propsInfo.expenseSeq ?? ''}`}
                      >
                        配分
                      </Button>
                      <Button
                        themeColor="secondary"
                        fillMode="flat"
                        onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
                          e.stopPropagation()
                          dispatch(SimulationBuildingSearchActions.setTarget(`${props.propsInfo.procurementNo ?? ''}-${props.propsInfo.subNo ?? ''}-${props.propsInfo.expenseSeq ?? ''}`))
                          handleDelete()
                        }}
                        disabled={deleteStatus()}
                        style={{ paddingTop: '0', paddingBottom: '0' }}
                      >
                        削除
                      </Button>
                    </ButtonGroup>
                  </GridLayoutItem>
                </GridLayout>
                {props.propsInfo.subNo === '00' && props.propsInfo.expenseSeq === '00' && isExistChildren
                  ? (
                  <div style={{ textAlign: 'right' }}>
                    <Button
                      themeColor="secondary"
                      fillMode="flat"
                      onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
                        e.stopPropagation()
                        handleExpand()
                      }}
                      style={{ paddingTop: '0', paddingBottom: '0' }}
                    >
                      {isExpanded ? '子物件非表示' : '子物件表示'}
                    </Button>
                  </div>
                    )
                  : (
                  <div style={{ height: '22.5px' }} />
                    )
                  }

              </GridLayoutItem>
            </GridLayout>
          </CardBody>
          {showFlg && (
            <DispatchAllotmentSheet
              allocationSupplierList={allocationSupplierList}
            />
          )}
        </Card>
      </div>

      {showSplitDialog && (
        <Window
          title={'物件情報メンテナンス　分割'}
          onClose={closeSplitDialog}
          initialWidth={1280}
          initialHeight={500}
          modal
        >
          <BuildingSplit
            key={`${maintenanceInfoPutState.procurementNo ?? ''}-${maintenanceInfoPutState.subNo ?? ''}-${maintenanceInfoPutState.expense ?? ''}-${maintenanceInfoPutState.expenseSeq ?? ''}`}
            pageType={2}
            params={{
              branchCd: props.propsInfo.branchCd ?? '',
              subNo: props.propsInfo.subNo ?? '',
              procurementNo: props.propsInfo.procurementNo ?? '',
              expenseCode: props.propsInfo.expense ?? '',
              expenseSeq: props.propsInfo.expenseSeq ?? ''
            }}
            buildingInfoSplitList={splitInfoPutState}
            setBuildingInfoSplitList={setSplitInfoPutState}
            setSignInBtnDisabled={setBuildingMaintenanceSignInBtnDisabled}
          />
          <StackLayout
            orientation="horizontal"
            align={{ horizontal: 'end' }}
            gap={5}
          >
            <Button
              onClick={closeSplitDialog}
              className="pcy-button-long"
            >
              戻る
            </Button>
            <Button
              onClick={handleRegSplit}
              className="pcy-button-long"
              themeColor="primary"
              disabled={splitInfoPutState.length === 0 || buildingMaintenanceSignInBtnDisabled}
            >
              登録
            </Button>
          </StackLayout>
        </Window>
      )}

      {showMaintenanceDialog && (
        <Window
          title={'物件情報メンテナンス　編集'}
          onClose={closeMaintenanceDialog}
          initialWidth={1280}
          initialHeight={500}
          modal
        >
          <BuildingMaintenance
            key={`${maintenanceInfoPutState.procurementNo ?? ''}-${maintenanceInfoPutState.subNo ?? ''}-${maintenanceInfoPutState.expense ?? ''}-${maintenanceInfoPutState.expenseSeq ?? ''}`}
            pageType={3}
            params={{
              branchCd: props.propsInfo.branchCd ?? '',
              subNo: props.propsInfo.subNo ?? '',
              procurementNo: props.propsInfo.procurementNo ?? '',
              expenseCode: props.propsInfo.expense ?? '',
              expenseSeq: props.propsInfo.expenseSeq ?? ''
            }}
            buildingInfoPut={maintenanceInfoPutState}
            buildingInfoPutStore={maintenanceInfoPutStore}
            setBuildingInfoPut={setMaintenanceInfoPutState}
            setBuildingInfoPutStore={setMaintenanceInfoPutStore}
            setSignInBtnDisabled={setBuildingMaintenanceSignInBtnDisabled}
          />
          <StackLayout
            orientation="horizontal"
            align={{ horizontal: 'end' }}
            gap={5}
          >
            <Button
              onClick={closeMaintenanceDialog}
              className="pcy-button-long"
            >
              戻る
            </Button>
            <Button
              onClick={handleRegMaintenance}
              className="pcy-button-long"
              themeColor="primary"
              disabled={buildingMaintenanceSignInBtnDisabled}
            >
              登録
            </Button>
          </StackLayout>
        </Window>
      )}
      <ConfirmDialog
        open={confirmDialogShow}
        renderCloseButton
        title={title}
        id={messageId}
        args={messageArgslist}
        onClickOk={dialogConfirmHandleBtn}
        onClickCancel={() => setConfirmDialogShow(false)}
      />
      </>
      )}
    </>
  )
}
